// Copyright (c) 2017 Deere & Company

import * as claimActions from '../../action-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';

const actions = {
    ...claimActions,
    ...userActions
};

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.dealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.dealerAccounts
            }
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>

    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_DEALER_INVOICE_FILTERS]: resetAllFacets,
        [actions.TOGGLE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers,
        [actions.SELECT_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS]: updateDealerAccountItems
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/reducers/facets.js